export default "__VITE_ASSET__B30wUSTm__"